import {
  ApplicationConfig,
  provideZonelessChangeDetection,
  provideBrowserGlobalErrorListeners,
  isDevMode, APP_INITIALIZER
} from '@angular/core';
import {provideRouter, withComponentInputBinding} from '@angular/router';
import {provideHttpClient, withFetch, withInterceptors} from '@angular/common/http';

import {routes} from './app.routes';
import {provideClientHydration, withEventReplay} from '@angular/platform-browser';
import {provideServiceWorker} from '@angular/service-worker';
import {provideCharts, withDefaultRegisterables} from 'ng2-charts';
import {provideAnimationsAsync} from '@angular/platform-browser/animations/async';
import {provideZard} from './core/provider/providerzard';
import {tokenInterceptor} from './core/interceptors/token.interceptor';
import {errorInterceptor} from './core/interceptors/error.interceptor';
import {UserService} from './core/auth/services/user.service';
import {CandidatureContextService} from './features/tenant/models/candidature-context';

function initializeAuth(userService: UserService) {
  return () => userService.initializeSession();
}

export const appConfig: ApplicationConfig = {
  providers: [
    CandidatureContextService,
    provideZonelessChangeDetection(),
    provideRouter(routes, withComponentInputBinding()),
    provideHttpClient(withFetch(), withInterceptors([tokenInterceptor, errorInterceptor])),
    provideClientHydration(withEventReplay()),
    provideServiceWorker('ngsw-worker.js', {
      enabled: !isDevMode(),
      registrationStrategy: 'registerWhenStable:30000'
    }),
    provideBrowserGlobalErrorListeners(),
    provideAnimationsAsync(),
    provideZard(),
    provideCharts(withDefaultRegisterables()),
    {
      provide: APP_INITIALIZER,
      useFactory: (userService: UserService) => initializeAuth(userService),
      deps: [UserService],
      multi: true // allows multiple APP_INITIALIZERs to coexist
    }
  ]
};
